module.exports = __webpack_public_path__ + "img/MottoCenter-D-TOOLS-Learn.01ea4247.png";